// This file is auto-generated by scripts/generate-image-manifest.mjs
// Run: npm run images:manifest

const imageManifest = [
  {
    "fileName": "DSC_6810.jpg",
    "src": "/images/DSC_6810.jpg",
    "bytes": 1763769
  },
  {
    "fileName": "DSC_6815.jpg",
    "src": "/images/DSC_6815.jpg",
    "bytes": 1814762
  },
  {
    "fileName": "DSC_6821.jpg",
    "src": "/images/DSC_6821.jpg",
    "bytes": 2131529
  },
  {
    "fileName": "DSC_6823.jpg",
    "src": "/images/DSC_6823.jpg",
    "bytes": 1876191
  },
  {
    "fileName": "DSC_6844 (1).jpg",
    "src": "/images/DSC_6844%20(1).jpg",
    "bytes": 1756662
  },
  {
    "fileName": "garden1.jpeg",
    "src": "/images/garden1.jpeg",
    "bytes": 469321
  },
  {
    "fileName": "garden2.jpeg",
    "src": "/images/garden2.jpeg",
    "bytes": 405464
  },
  {
    "fileName": "garden3.jpeg",
    "src": "/images/garden3.jpeg",
    "bytes": 331588
  },
  {
    "fileName": "img1.jpg",
    "src": "/images/img1.jpg",
    "bytes": 527714
  },
  {
    "fileName": "img3.jpg",
    "src": "/images/img3.jpg",
    "bytes": 644374
  },
  {
    "fileName": "img4.jpg",
    "src": "/images/img4.jpg",
    "bytes": 328734
  },
  {
    "fileName": "img5.jpg",
    "src": "/images/img5.jpg",
    "bytes": 321313
  },
  {
    "fileName": "img6.jpeg",
    "src": "/images/img6.jpeg",
    "bytes": 315968
  },
  {
    "fileName": "img8.jpeg",
    "src": "/images/img8.jpeg",
    "bytes": 349664
  },
  {
    "fileName": "img9.jpg",
    "src": "/images/img9.jpg",
    "bytes": 469532
  },
  {
    "fileName": "img10.jpg",
    "src": "/images/img10.jpg",
    "bytes": 270591
  },
  {
    "fileName": "img11.jpeg",
    "src": "/images/img11.jpeg",
    "bytes": 576402
  },
  {
    "fileName": "img12.jpeg",
    "src": "/images/img12.jpeg",
    "bytes": 176156
  },
  {
    "fileName": "img13.jpeg",
    "src": "/images/img13.jpeg",
    "bytes": 315968
  },
  {
    "fileName": "img14.jpg",
    "src": "/images/img14.jpg",
    "bytes": 233813
  },
  {
    "fileName": "img15.jpg",
    "src": "/images/img15.jpg",
    "bytes": 230079
  },
  {
    "fileName": "img16.jpg",
    "src": "/images/img16.jpg",
    "bytes": 410990
  },
  {
    "fileName": "img17.jpeg",
    "src": "/images/img17.jpeg",
    "bytes": 331558
  },
  {
    "fileName": "img18.jpg",
    "src": "/images/img18.jpg",
    "bytes": 318054
  },
  {
    "fileName": "img19.jpg",
    "src": "/images/img19.jpg",
    "bytes": 145595
  },
  {
    "fileName": "img20.jpg",
    "src": "/images/img20.jpg",
    "bytes": 191103
  },
  {
    "fileName": "img21.jpg",
    "src": "/images/img21.jpg",
    "bytes": 296338
  },
  {
    "fileName": "img22.jpg",
    "src": "/images/img22.jpg",
    "bytes": 462175
  },
  {
    "fileName": "img23.jpg",
    "src": "/images/img23.jpg",
    "bytes": 463558
  },
  {
    "fileName": "img24.jpg",
    "src": "/images/img24.jpg",
    "bytes": 211993
  },
  {
    "fileName": "img25.jpg",
    "src": "/images/img25.jpg",
    "bytes": 438731
  },
  {
    "fileName": "img26.jpg",
    "src": "/images/img26.jpg",
    "bytes": 342408
  },
  {
    "fileName": "img27.jpg",
    "src": "/images/img27.jpg",
    "bytes": 175011
  },
  {
    "fileName": "img28.jpg",
    "src": "/images/img28.jpg",
    "bytes": 201861
  },
  {
    "fileName": "img29.jpg",
    "src": "/images/img29.jpg",
    "bytes": 205401
  },
  {
    "fileName": "img30.jpg",
    "src": "/images/img30.jpg",
    "bytes": 271497
  },
  {
    "fileName": "img31.jpeg",
    "src": "/images/img31.jpeg",
    "bytes": 391126
  },
  {
    "fileName": "img32.jpg",
    "src": "/images/img32.jpg",
    "bytes": 313481
  },
  {
    "fileName": "img34.jpg",
    "src": "/images/img34.jpg",
    "bytes": 544921
  },
  {
    "fileName": "img35.jpg",
    "src": "/images/img35.jpg",
    "bytes": 643503
  },
  {
    "fileName": "img36.jpg",
    "src": "/images/img36.jpg",
    "bytes": 353639
  },
  {
    "fileName": "img37.jpg",
    "src": "/images/img37.jpg",
    "bytes": 232160
  },
  {
    "fileName": "img38.jpg",
    "src": "/images/img38.jpg",
    "bytes": 299373
  },
  {
    "fileName": "img39.jpg",
    "src": "/images/img39.jpg",
    "bytes": 353639
  },
  {
    "fileName": "img40.jpg",
    "src": "/images/img40.jpg",
    "bytes": 375013
  },
  {
    "fileName": "img42.jpg",
    "src": "/images/img42.jpg",
    "bytes": 482574
  },
  {
    "fileName": "img43.jpg",
    "src": "/images/img43.jpg",
    "bytes": 268680
  },
  {
    "fileName": "img46.jpg",
    "src": "/images/img46.jpg",
    "bytes": 262251
  },
  {
    "fileName": "img47.jpg",
    "src": "/images/img47.jpg",
    "bytes": 295854
  },
  {
    "fileName": "img48.jpg",
    "src": "/images/img48.jpg",
    "bytes": 299373
  },
  {
    "fileName": "img49.jpg",
    "src": "/images/img49.jpg",
    "bytes": 281243
  },
  {
    "fileName": "img50.jpg",
    "src": "/images/img50.jpg",
    "bytes": 464734
  },
  {
    "fileName": "img51.jpeg",
    "src": "/images/img51.jpeg",
    "bytes": 25359
  },
  {
    "fileName": "supermarket.jpeg",
    "src": "/images/supermarket.jpeg",
    "bytes": 387118
  },
  {
    "fileName": "supermarket2.jpeg",
    "src": "/images/supermarket2.jpeg",
    "bytes": 246252
  },
  {
    "fileName": "sweets.jpeg",
    "src": "/images/sweets.jpeg",
    "bytes": 8300
  }
];

export default imageManifest;
